import { Navigate, useNavigate } from 'react-router';

import { OffRampKycOnboarding } from '@sorare/core/src/components/offRamp/OffRampKycOnboarding';
import {
  LANDING,
  WALLET,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

const OffRampKycOnboardingPage = () => {
  const navigate = useNavigate();
  const { currentUser } = useCurrentUserContext();

  if (!currentUser) {
    return <Navigate to={LANDING} />;
  }

  return <OffRampKycOnboarding onDone={() => navigate(WALLET)} />;
};

export default OffRampKycOnboardingPage;
